import i18n from 'i18n';

// Leaderboards. Display names live in the translation files under
// `leaderboards.<tag>.name` / `leaderboards.<tag>.short`.
const leaderboard = [
    {tag: "singles_t", content: null, lb_type: 0, value: (x) => x.value},
    {tag: "singles_s", content: null, lb_type: 0, value: (x) => x.value},
    {tag: "singles_f", content: null, lb_type: 0, value: (x) => x.value},
    {tag: "singles_m", content: null, lb_type: 0, value: (x) => x.value},
    {tag: "singles_e", content: null, lb_type: 0, value: (x) => `${x.value} ${i18n.t("common.pts")}`},
    {tag: "doubles_t", content: null, lb_type: 0, value: (x) => x.value},
    {tag: "doubles_s", content: null, lb_type: 0, value: (x) => x.value},
    {tag: "doubles_f", content: null, lb_type: 0, value: (x) => x.value},
    {tag: "doubles_m", content: null, lb_type: 0, value: (x) => x.value},
    {tag: "doubles_e", content: null, lb_type: 0, value: (x) => `${x.value} ${i18n.t("common.pts")}`},
    {tag: "club_fs", content: null, lb_type: 1, value: (x) => x.value},
    {tag: "club_fd", content: null, lb_type: 1, value: (x) => x.value},
    {tag: "club_t", content: null, lb_type: 1, value: (x) => x.value},
]

// Filters are keyed by a language neutral key -> backend value.
// Labels are resolved at render time (see components/FilterButton.js).
const rankFilter = {"3": 3, "5": 5, "10": 10, "15": 15, "20": 20, "25": 25, "30": 30, "35": 35, "40": 40, "45": 45,
"50": 50, "55": 55, "60": 60, "65": 65, "70": 70, "75": 75, "80": 80, "85": 85, "90": 90, "95": 95,
"100": 100, "105": 105, "110": 110}
const pyramidFilter = {"M": "M", "V": "V", "V13": "V13", "M13": "M13", "V11": "V11", "M11": "M11", "U09": "U09"}


const constants = {
    "BACKEND": "/api/v2",
    "LEADERBOARD": leaderboard,
    "FILTERS": {"RANK": rankFilter, "PYRAMID": pyramidFilter}
}

export default constants;
